export default "__VITE_ASSET__218f18ef__"